import {
  useMutation,
  UseMutationOptions,
  UseMutationResult,
  useQueryClient,
} from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { axiosInstance } from '../../axios';
import { AD_ASSETS_QUERY_KEY } from '../adCreativesQuery';
import { ImportStockPhotoParams, ImportStockPhotoResult, StockApiResponse } from './types';
import { STOCK_USAGE_QUERY_KEY } from './useGetStockUsage';

/**
 * Jedyne wywołanie, które zużywa pulę pobrań. Wolno je odpalić wyłącznie po
 * jawnym potwierdzeniu przez użytkownika, nigdy automatycznie przy przeglądaniu
 * wyników. Backend pilnuje tego samego od drugiej strony: liczy pobrania w
 * dobie i odsyła zdjęcie z biblioteki, jeśli już je mamy.
 */
export const useImportStockPhoto = (
  options?: UseMutationOptions<ImportStockPhotoResult, AxiosError, ImportStockPhotoParams>,
): UseMutationResult<ImportStockPhotoResult, AxiosError, ImportStockPhotoParams> => {
  const queryClient = useQueryClient();

  return useMutation<ImportStockPhotoResult, AxiosError, ImportStockPhotoParams>({
    mutationFn: async (params) => {
      const res = await axiosInstance.post<StockApiResponse<ImportStockPhotoResult>>(
        '/v3-importStockPhoto',
        params,
        { timeout: 120_000 },
      );
      return res.data.data;
    },
    ...options,
    onSuccess: (...args) => {
      queryClient.invalidateQueries({ queryKey: AD_ASSETS_QUERY_KEY });
      queryClient.invalidateQueries({ queryKey: STOCK_USAGE_QUERY_KEY });
      options?.onSuccess?.(...args);
    },
  });
};
